module.exports = __webpack_public_path__ + "static/media/close.8bcbd59e.svg";